import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface ModalProps {
  header: React.ReactNode;
  body: React.ReactNode;
  footer: React.ReactNode;
  alignHeaderToBottom?: boolean;
  disableClose?: boolean;
  shouldModalClose?: boolean;
  shouldModalNavigate?: string;
}

export default function ModalComponent({
  header,
  body,
  footer,
  alignHeaderToBottom,
  disableClose,
  shouldModalClose,
  shouldModalNavigate = "",
}: ModalProps) {
  const navigate = useNavigate();

  useEffect(() => {
    // Attach event listeners
    window.addEventListener("popstate", () => onRouteChange());

    // Cleanup listeners when component is unmounted
    return () => {
      window.removeEventListener("popstate", () => onRouteChange());
    };
  }, []);

  useEffect(() => {
    onModalOpen();
    shouldModalClose && onModalClose();
  }, [shouldModalClose]);

  const onModalOpen = () => {
    const button = document.createElement("button");
    button.setAttribute("data-bs-toggle", "modal");
    button.setAttribute("data-bs-target", "#modal");
    document.body.appendChild(button);

    // Check if bootstrap is loaded before 'clicking'
    const checkScriptsLoaded = () => {
      if (typeof window.bootstrap !== "undefined") {
        button.click();
        button.remove();
      } else {
        setTimeout(checkScriptsLoaded, 100);
      }
    };

    checkScriptsLoaded();
  };

  const onModalClose = () => {
    const closeButton = document.getElementById("close-modal-btn");
    closeButton && closeButton.click();

    setTimeout(() => navigate(-1), 300);
  };

  const onRouteChange = () => {
    const backdrop = document.querySelector(".modal-backdrop.fade.show");
    if (backdrop) {
      backdrop.remove();
    }
  };

  const onBackNavigate = () => {
    setTimeout(() => {
      !!shouldModalNavigate ? navigate(shouldModalNavigate, { replace: true }) : navigate(-1);
    }, 300);
  };

  return (
    <div className="modal modal-blur fade" id="modal" tabIndex={-1} role="dialog">
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title" style={alignHeaderToBottom ? { alignSelf: "end" } : undefined}>
              {header}
            </div>
            <button
              id="close-modal-btn"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onBackNavigate}
              disabled={disableClose}
            ></button>
          </div>
          <div className="modal-body">{body}</div>
          {footer && <div className="modal-footer">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
